import { render, staticRenderFns } from "./loadingS.vue?vue&type=template&id=77637f87&scoped=true&"
import script from "./loadingS.vue?vue&type=script&lang=js&"
export * from "./loadingS.vue?vue&type=script&lang=js&"
import style0 from "./loadingS.vue?vue&type=style&index=0&id=77637f87&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77637f87",
  null
  
)

export default component.exports